import { RydeUiUnit } from "../../models";

/** Where one scrollable area was scrolled to, and the page that owns the offset. */
export interface IScrollPositionEntry {
  scrollTop: number;
  scrollLeft: number;
  pageKey: RydeUiUnit;
}

/** Hard stop for a restore, so a target the content can never reach cannot retry forever. */
export const SCROLL_POSITION_RESTORE_TIMEOUT_MS = 2000;

/** A scroll the user asked for out-ranks a restore that is still waiting for rows to arrive. */
export const SCROLL_POSITION_USER_INTENT_EVENTS = [
  "wheel",
  "touchstart",
  "pointerdown",
  "keydown",
] as const;
